import { render, staticRenderFns } from "./DarkFooter.vue?vue&type=template&id=31b2c4f2&scoped=true"
import script from "./DarkFooter.vue?vue&type=script&lang=js"
export * from "./DarkFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2c4f2",
  null
  
)

export default component.exports